<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">End automation is coming soon!</h4>
</div>